import RsaRiepiloghiPage from "./pages/RsaRiepiloghiPage.vue";


export default {    RsaRiepiloghiPage
};